export default {
  product: {
    name: 'Osta lahjakortti',
  },
  description: {
    items: {
      delivery: 'Lähetetään heti sähköpostitse PDF-muodossa',
      usage: {
        online: 'Lunastettavissa vain verkossa',
        online_and_store: 'Lunastettavissa verkossa ja ravintolassa',
      },
      value: 'Joustavat summat väliltä {{from}}–{{to}}',
    },
  },
};
